exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more[data-v-95538fb4]{min-width:96px;vertical-align:top;text-decoration:none;text-align:center;cursor:pointer;line-height:18px;font-weight:700;border-radius:2px;font-family:Open Sans,sans-serif;text-transform:uppercase;font-size:12px;transition:all .2s ease-in;padding:6px 0;color:#6e6bce;border:2px solid #6e6bce;background-color:transparent;outline:none}.more[data-v-95538fb4]:hover{background-color:#6e6bce;color:#fff}.more_cancel[data-v-95538fb4]{color:#fff;background-color:#ec3d3b;border-color:#ec3d3b}.more_cancel[data-v-95538fb4]:hover{background-color:#51d675;border-color:#51d675}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-95538fb4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/vacancies/card/components/btn/Button.vue
// module id = 91a496cdede00005e7a0
// module chunks = 0